import type { JSX } from 'react';
import type { ChatRole } from '../../chatbot.types';
import { useChatbotConfig, type AvatarConfig } from '../../ChatbotProvider';

type Props = { role: ChatRole };

const DefaultAvatar = ({ role }: { role: string }): JSX.Element => (
  <div className={`chatbot-avatar chatbot-avatar--${role}`}>
    <span className='chatbot-avatar-initials'>{role[0]?.toUpperCase()}</span>
  </div>
);

const AvatarFromConfig = ({ config }: { config: AvatarConfig }): JSX.Element => {
  if (config.type === 'custom' && config.component) {
    const Custom = config.component;
    return <Custom />;
  }

  if (config.type === 'image' && config.value) {
    return (
      <div className={config.className ?? 'chatbot-avatar'}>
        <img src={config.value} alt={config.alt ?? ''} className='chatbot-avatar-img' />
      </div>
    );
  }

  // Initials or fallback
  return (
    <div className={config.className ?? 'chatbot-avatar'}>
      <span className='chatbot-avatar-initials'>{config.value ?? '?'}</span>
    </div>
  );
};

export const ChatAvatar = ({ role }: Props): JSX.Element => {
  const { avatar } = useChatbotConfig();
  const config = avatar?.[role];

  if (config) {
    return <AvatarFromConfig config={config} />;
  }

  return <DefaultAvatar role={role} />;
};
